import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	Stepper,
	Step,
	StepButton,
	withStyles,
	StepLabel,
} from '@material-ui/core'
import { stepperGoTo } from 'actions/view'

const StepperComponent = ({
	activeStep,
	steps,
	classes,
	stepperGoTo,
	newEntity,
}) => (
	<Stepper
		classes={{ root: classes.root }}
		activeStep={activeStep}
		alternativeLabel
		nonLinear
	>
		{steps.map((step, idx) => (
			<Step key={step.label}>
				<StepButton
					classes={
						newEntity
							? idx !== 0
								? { root: classes.stepButtonRootDisabled }
								: null
							: null
					}
					icon={step.Icon}
					onClick={() =>
						newEntity
							? idx !== 0
								? console.log('disabled')
								: stepperGoTo(idx, 'campaign')
							: stepperGoTo(idx, 'campaign')
					}
				>
					<StepLabel
						classes={{
							alternativeLabel: classes.alternativeLabel,
							active: classes.active,
						}}
					>
						{step.label}
					</StepLabel>
				</StepButton>
			</Step>
		))}
	</Stepper>
)

const styles = (theme) => ({
	root: {
		padding: 0,
		marginTop: '-9px',
	},
	alternativeLabel: {
		marginTop: '0px !important',
		whiteSpace: 'nowrap',
		[theme.breakpoints.down('sm')]: {
			fontSize: 10,
		},
	},
	stepButtonRootDisabled: {
		cursor: 'default',
	},
	active: {
		color: '#18b940 !important',
	},
})

export default connect(
	(state) => ({ activeStep: state.view.stepper.campaign }),
	(dispatch) => bindActionCreators({ stepperGoTo }, dispatch),
)(withStyles(styles)(StepperComponent))
